import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location?: string;
  quote: string;
  image?: string; // Optional avatar
  rating?: number;
}
export function TestimonialCard({
  name,
  location,
  quote,
  image,
  rating = 5
}: TestimonialCardProps) {
  return <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 my-6 shadow-sm" data-id="element-12">
      <div className="flex gap-1 mb-3 text-yellow-400" data-id="element-13">
        {[...Array(rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-14" />)}
      </div>
      <blockquote className="text-gray-800 text-lg italic leading-relaxed mb-4" data-id="element-15">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-3" data-id="element-16">
        {image ? <img src={image} alt={name} className="w-10 h-10 rounded-full object-cover" data-id="element-17" /> : <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-sm" data-id="element-18">
            {name.charAt(0)}
          </div>}
        <div data-id="element-19">
          <div className="font-bold text-gray-900" data-id="element-20">{name}</div>
          {location && <div className="text-sm text-gray-500" data-id="element-21">{location}</div>}
        </div>
      </div>
    </div>;
}